import { defineRecipe } from "@chakra-ui/react";

export const input = defineRecipe({
  base: {
    colorPalette: "accent",
    transitionProperty: "common",
    transitionDuration: "moderate",
  },
});
